import React, {useEffect, useState} from "react";
import {useLanguageForShared} from "../../../../../../../shared/utils/languages/useLanguageForShared";
import {FormElements} from "../../../../../../../shared/bootstrap/form/FormElements";
import FormGroup from "../../../../../../../shared/bootstrap/form/form-group/FormGroup";
import InputCustom from "../../../../../../../shared/bootstrap/form/input/InputCustom";
import {useTemplateFormLOX_POC_TOC_COX} from "../data/useTemplateFormLOX_POC_TOC_COX";
import {useTemplateFormOtherInfo} from "../data/useTemplateFormOtherInfo";
import {useParamsData} from "../data/useParamsData";
import {useEffectOnlyUpdate} from "../../../../../../../shared/utils/use_custom/useEffectCustom";
import {copyObject} from "../../../../../../../shared/utils/objUtils";
import {PrescriptionTemplate} from "./PrescriptionTemplate";


export function OtherInfoTemplate({dataForm, changeValue, errors, setData, isSubmit}) {
    const {t} = useLanguageForShared()

    const {
        formStructureValid,
        formStructureDateNextCheck,
        formPrescriptionType
    } = useTemplateFormLOX_POC_TOC_COX(t, dataForm);
    const {
        formStructureCannulaNasal, formStructureMask,
        formStructureDetailCannulaNasal, formStructureDetailMask
    } = useTemplateFormOtherInfo(t, dataForm);
    const {
        formStructureNote
    } = useParamsData(t, dataForm);

    useEffectOnlyUpdate(() => {
        if (!dataForm?.cannulaNasal) {
            const modeField = formStructureDetailCannulaNasal.map((ele) => ele.name).join(",").split(",");
            const copyDataForm = copyObject(dataForm);
            modeField?.forEach((key) => {
                delete copyDataForm[key];
            });
            setData(copyDataForm);
        }
    }, [dataForm?.cannulaNasal]);

    useEffect(() => {
        if (!dataForm?.mask) {
            const modeField = formStructureDetailMask.map((ele) => ele.name).join(",").split(",");
            const copyDataForm = copyObject(dataForm);
            modeField?.forEach((key) => {
                delete copyDataForm[key];
            });
            setData(copyDataForm);
        }
    }, [dataForm?.mask]);

    useEffect(() => {
        if (dataForm && !dataForm.validUntil) {
            setData({
                ...dataForm,
                validUntil: new Date().toISOString(),
            });
        }
    }, [dataForm]);

    return (
        <>
            <div className="form-card">
                <span className="form-card__title">{t('sg.otherInfoInterface')}</span>
                <FormElements
                    structure={formStructureCannulaNasal}
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                />
                <FormElements
                    structure={formStructureMask}
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                />
            </div>
            <FormElements
                structure={formStructureNote}
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                isSubmit={isSubmit}
            />
            <FormElements
                structure={[...formStructureValid, ...formStructureDateNextCheck, ...formPrescriptionType]}
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                isSubmit={isSubmit}
            />
        </>
    );
}
